import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["spinner"];
  connect() {
    this.reset = this.reset.bind(this);
    document.addEventListener("turbo:before-cache", this.reset);
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.reset);
  }
  click(event) {
    if (this.element.dataset.disabled === "true") {
      event.preventDefault();
      return;
    }

    this.element.dataset.disabled = "true";
    this.element.classList.add("opacity-50", "pointer-events-none");

    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }
  }
  reset() {
    console.log("reset patient-link");
    delete this.element.dataset.disabled;
    this.element.classList.remove("opacity-50", "pointer-events-none");
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }
}
